(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slideshow-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = 'slideshow-controls[data-wd-slide-label]';
  const translate = button => {
    const match = /^Slide (\d+) of (\d+)$/.exec(button.getAttribute('aria-label') || '');
    if (!match) return;
    const group = button.closest(selector);
    if (!group) return;
    const translated = group.dataset.wdSlideLabel.replace('__INDEX__', match[1]).replace('__LENGTH__', match[2]);
    if (translated !== button.getAttribute('aria-label')) button.setAttribute('aria-label', translated);
  };
  const scan = node => {
    if (!(node instanceof Element)) return;
    if (node.matches('button[aria-label]')) translate(node);
    node.querySelectorAll('button[aria-label]').forEach(translate);
  };

  if (customElements.get('wd-slide-labels')) return;
  customElements.define('wd-slide-labels', class extends HTMLElement {
    connectedCallback() {
      const group = this.parentElement;
      if (!group?.matches(selector)) return;
      this.observer = new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'attributes') translate(record.target);
          else record.addedNodes.forEach(scan);
        }
      });
      this.observer.observe(group, {subtree:true, childList:true, attributes:true, attributeFilter:['aria-label']});
      scan(group);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-contact-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.getElementById('wd-contact-dialog');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    let opener;
    const open = (source) => {
      opener = source || document.activeElement;
      if (!dialog.open) dialog.showModal();
      document.documentElement.classList.add('wd-contact-is-open');
      const target = dialog.querySelector('[data-wd-contact-result]') || dialog.querySelector('#wd-contact-name');
      target?.focus();
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-wd-contact-open]');
      if (!trigger) return;
      event.preventDefault();
      open(trigger);
    });
    dialog.querySelector('[data-wd-contact-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('wd-contact-is-open');
      opener?.focus();
    });
    if (window.location.hash === '#WdContactForm' && dialog.querySelector('[data-wd-contact-result]')) open();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wd-vat-collapse"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-tax-widget="cart"]';
  const enhance = widget => {
        if (!widget.isConnected || widget.querySelector('.wd-vat-details')) return;
        const title = widget.querySelector('[data-tax-role="title"]');
        const form = widget.querySelector('[data-tax-role="form"]');
        if (!title || !form) return;
        const details = document.createElement('details');
        details.className = 'wd-vat-details';
        const summary = document.createElement('summary');
        summary.append(title);
        details.append(summary);
        Array.from(widget.children).forEach(child => {
          if (child.tagName !== 'STYLE') details.append(child);
        });
        widget.append(details);
        if (form.querySelector('input:not([type="hidden"])')?.value) details.open = true;
        details.addEventListener('invalid', () => { details.open = true; }, true);

  };
  const pending = new Set();
  let queued = false;
  const queue = widget => {
    if (!widget || widget.querySelector('.wd-vat-details')) return;
    pending.add(widget);
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      const widgets = [...pending];
      pending.clear();
      widgets.forEach(enhance);
    });
  };
  const scan = node => {
    if (!(node instanceof Element)) return;
    if (node.matches(selector)) queue(node);
    node.querySelectorAll(selector).forEach(queue);
  };
  if (customElements.get('wd-vat-observer')) return;
  customElements.define('wd-vat-observer', class extends HTMLElement {
    connectedCallback() {
      const cart = this.parentElement;
      if (!cart?.matches('cart-items-component')) return;
      this.observer = new MutationObserver(records => {
    for (const record of records) {
      if (!(record.target instanceof Element)) continue;
      queue(record.target.closest(selector));
      record.addedNodes.forEach(scan);
    }
      });
      this.observer.observe(cart, {childList:true, subtree:true});
      cart.querySelectorAll(selector).forEach(enhance);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
